import React from 'react'

export default ({
  currentSite,
  openModal,
  handleSignInSuccess
}) => {
  const signInUrl = '/sign_in'

  const openSignInModal = event => {
    event.preventDefault()
    openModal({
      type: 'signIn',
      payload: {
        currentSite,
        onSignInSuccess: handleSignInSuccess,
        welcomeMsg: 'Great to have you back!'
      }
    })
  }

  return (
    <li className='global-header-menu__list-item -background-light -border-radius'>
      <a
        href={signInUrl}
        onClick={openSignInModal}
        className='global-header-menu__link fds-u-pl1'
      >
        <span className='global-header-menu__link-text'>
          Sign In
        </span>
      </a>
    </li>
  )
}



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/guestMenu.js